<template>
  <el-dialog title="选择ERP商品匹配" @close="close" :visible.sync="visible" width="1280px">
    <div>
      <el-form ref="ruleForm" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="" prop="outerId">
          <SearchInput
            v-model="formInline.outerId"
            :attrs="{
              placeholder: '款式编码，多个用英文逗号分隔',
              label: '款式编码',
              isDialog: true,
            }"
            @search="onSubmit"
          ></SearchInput>
        </el-form-item>
        <el-form-item label="" prop="skuOuterId">
          <SearchInput
            v-model="formInline.skuOuterId"
            :attrs="{ placeholder: '商品编码，多个用英文逗号分隔', label: '商品编码', isDialog: true }"
            @search="onSubmit"
          ></SearchInput>
        </el-form-item>
        <el-form-item label="">
          <!-- <el-date-picker
					v-model="formInline.time"
					:unlink-panels="true"
					type="daterange"
					value-format="timestamp"
					range-separator="至"
					:picker-options="pickerOptions"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
					</el-date-picker> -->
          <ZDateRange style="width: 380px !important" :startTime.sync="formInline.startTime" :endTime.sync="formInline.endTime" />
        </el-form-item>
        <el-form-item label="" prop="title">
          <el-input v-model="formInline.title" @keydown.enter.native="onSubmit" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="resetForm('ruleForm')">清空</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="tableRef" :data="tableData" height="400px">
        <template v-for="item in columns">
          <el-table-column v-if="item.type === 'img'" :key="item.prop + '1'" v-bind="item">
            <template v-slot="{ row }">
              <div style="display: flex; align-items: center">
                <ListLazyImg :size="{ width: 40, height: 40 }" :src="`${row.picPath}`" />
              </div>
            </template>
          </el-table-column>
          <el-table-column v-else :key="item.prop + '1'" v-bind="item"> </el-table-column>
        </template>
        <el-table-column label="操作">
          <template v-slot="{ row }">
            <el-button type="link" @click="sure(row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row style="margin-top: 10px" type="flex" justify="end">
        <Pagination :limit.sync="pageParams.pageSize" :page.sync="pageParams.pageNo" :total="total" @pagination="getListErpItem" />
      </el-row>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="sure">确 定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import { getListErpItem } from '@/api/prod/center';
import TableList from '@/components/TableList.vue';
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import Pagination from '@/components/pagination.vue';
import SearchInput from '@/components/prod/center/components/SearchInput.vue';
import ZDateRange from '@/components/prod/center/components/z-date-range2.vue';

import _ from 'lodash';
import dayjs from 'dayjs';

export default {
  props: {},
  components: {
    TableList,
    ListLazyImg,
    SearchInput,
    Pagination,
    ZDateRange,
  },
  data() {
    return {
      total: 0,
      visible: false,
      formInline: {
        outerId: '',
        skuOuterId: '',
        importStatus: '',
        title: '',
      }, // 查询条件数据
      tableData: [], // 表格数据
      selectionData: [], // 勾选数据
      columns: [
        { prop: '', label: '', type: 'index' },
        { prop: 'picPath', label: '商品图片', type: 'img' },
        { prop: 'title', label: '商品名称' },
        { prop: 'outerId', label: '款式编码' },
        { prop: 'skuOuterId', label: '商品编码' },
        { prop: 'propertiesName', label: '规格名称' },
        // {prop: 'brandName', label: '品牌'},
        // {prop: 'sellingPrice', label: '销售价'},
        // {prop: 'purchasePrice', label: '市场价', formatter: (row)=> {
        // 	return vm.getMarketPrice(row.extendFieldValues)
        // }},
        { prop: 'itemCategoryNames', label: '商品分类' },
        // {prop: 'modified', label: '更新时间', width: '135px'},
        // {prop: 'importStatus', label: '状态', formatter: (row)=> {
        // 	return row.importStatus?'已导入':'未导入'
        // }},
      ],
      sureFn: null,
      pageParams: {
        pageNo: 1,
        pageSize: 20,
      },
      pickerOptions: {
        disabledDate(time, a) {
          return time.getTime() > time.getTime() + 1000 * 60 * 60 * 24 * 30;
        },
      },
    };
  },
  methods: {
    openDialog(opts) {
      this.sureFn = opts.sureFn || null;
      this.initParams();
      this.getListErpItem();
      this.visible = true;
    },
    // 初始化数据
    initParams() {
      let date = dayjs(dayjs().format('YYYY-MM-DD'));
      let time = date.add(1, 'day').valueOf() - 1,
        startTime = date.subtract(6, 'day').valueOf();
      this.$set(this.formInline, 'startTime', startTime);
      this.$set(this.formInline, 'endTime', time);
    },
    sure(row) {
      this.sureFn && this.sureFn(row);
    },
    close() {
      this.visible = false;
      this.pageParams = {
        pageNo: 1,
        pageSize: 20,
      };
      this.formInline = {
        outerId: '',
        skuOuterId: '',
        importStatus: '',
        title: '',
      };

      this.$emit('search');
    },
    // 查询
    onSubmit(e) {
      this.pageParams = {
        pageNo: 1,
        pageSize: 20,
      };
      this.getListErpItem();
    },
    // 重置查询条件
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.formInline = {
        outerId: '',
        skuOuterId: '',
        importStatus: '',
        title: '',
      };
      this.initParams();
      this.getListErpItem();
    },
    // 勾选事件
    selectionChange(selection) {
      this.selectionData = selection;
    },
    // 获取列表数据
    getListErpItem() {
      if (
        this.formInline.startTime &&
        this.formInline.endTime &&
        this.formInline.endTime - this.formInline.startTime > 1000 * 60 * 60 * 24 * 30
      ) {
        this.$message({
          type: 'warning',
          message: '查询时间不能超过30天',
        });
        return;
      }
      let params = {
        ...this.formInline,
        ...this.pageParams,
        startTime: dayjs(this.formInline.startTime).format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(this.formInline.endTime).format('YYYY-MM-DD HH:mm:ss'),
      };
      getListErpItem({ ...params }).then(res => {
        this.tableData = res.data.list || [];
        this.total = res.data.total || 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>